import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IrisUserService } from '@iris/common/services/user.service';
import { take, tap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const BASE_HREF = '/ui/ui2/';
const ANGULAR_JS_BASE_HREF = '/ui/ui/';

@Component({
  selector: 'app-start-page',
  template: ``,
})
export class StartPageComponent implements OnInit {
  private readonly userService = inject(IrisUserService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.userService.getMeStartPageUrl().pipe(
      take(1),
      tap((startPageUrl) => {
        if (startPageUrl.startsWith(ANGULAR_JS_BASE_HREF)) {
          window.location.replace(startPageUrl);
        }

        const urlParts = startPageUrl.replace(BASE_HREF, '').split('/');
        void this.router.navigate(urlParts, {
          relativeTo: this.route.parent,
        });
      }),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();
  }
}
